/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsSequentialAvailableSlotsResponse } from "../../entities/models/SequentialAvailableSlotsResponse";
import { modelsSequentialAvailableSlotSchema } from "./sequentialAvailableSlotSchema";
import { z } from "zod/v4";

export const modelsSequentialAvailableSlotsResponseSchema = z.object({
    get "slots"(){
                return z.array(modelsSequentialAvailableSlotSchema).optional()
              }
    }) as unknown as z.ZodType<ModelsSequentialAvailableSlotsResponse>